<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Company
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/company/sub-visual-company.jpg"></v-img>
            <sub-tab page="회사소개" :tabActive="3"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: partners -->
        <section class="sub-section sub-section--partners">
            <v-container>
                <div class="tit-wrap">
                    <h3 align="center" class="tit tit--lg line-height-135" data-aos="fade-up">
                        업계를 선도하는 유통업체 모두에프엔티와 협력관계를 구축하고 <br class="d-none d-xl-block" />
                        상생의 가치를 나누는 기업들을 소개합니다.
                    </h3>
                </div>
                <div class="border-top border-start">
                    <v-row no-gutters>
                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/1.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/2.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/3.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/4.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/5.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/6.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/7.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/8.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/9.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/10.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/11.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/12.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/13.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/14.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/15.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/16.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/17.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/18.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/19.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/20.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/21.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/22.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/23.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/24.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/25.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/26.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/27.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/28.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/29.png"></v-img>
                            </div>
                        </v-col>

                        <v-col cols="6" md="4" lg="2">
                            <div class="border-bottom border-end" align="center">
                                <v-img max-width="238" src="/images/sub/company/partners/30.png"></v-img>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
        <!-- E: partners -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
